export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4687.03e8a1e2.jpg";